exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "*{-webkit-box-sizing:border-box;box-sizing:border-box}#app{font-family:Avenir,Helvetica,Arial,sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#2c3e50;padding:60px}a.app-link{margin-right:16px;font-weight:500;color:#08f;text-decoration:none;-webkit-transition:color .4s ease;transition:color .4s ease}@media (hover:hover){a.app-link:hover{color:#005299}}.text-center{text-align:center}", ""]);

// exports
